import { Component, Input } from "@angular/core";
import { LoadingController } from "ionic-angular";
import { StripeManager } from "../../managers/stripe.manager";

@Component({
  selector: "app-stripe-button",
  templateUrl: "./stripe-button.component.html",
})
export class StripeButtonComponent {
  @Input() voucherId: string;
  @Input() label: string;

  constructor(
    private _stripeManager: StripeManager,
    private _loadingCtrl: LoadingController
  ) {}

  handleClick() {
    let loading = this._loadingCtrl.create({
      spinner: "ios",
    });

    loading.present();
    this._stripeManager.checkout(this.voucherId).subscribe(
      (result) => {
        loading.dismiss();
      },
      () => {
        loading.dismiss();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/stripe-button/stripe-button.component.ts